export function detectSmsPlatform(device) {
  const ua = device.userAgent || '';
  const ios = /iPad|iPhone|iPod/i.test(ua) || (/Mac/i.test(device.platform || '') && device.maxTouchPoints > 1);
  return ios ? 'ios' : /Android/i.test(ua) ? 'android' : 'desktop';
}

export function buildSmsUrl(phone, message, platform) {
  const digits = String(phone).replace(/[\s().-]/g, '');
  if (!/^\+[1-9]\d{7,14}$/.test(digits)) return null;
  return `sms:${digits}${platform === 'ios' ? '&' : '?'}body=${encodeURIComponent(message)}`;
}

if (typeof document !== 'undefined') {
  const platform = detectSmsPlatform(navigator);
  let widgetController;
  let previousTrigger;

  function currentMessage(link) {
    if (link.classList.contains('rp-sms-link--launcher')) {
      const productLink = document.querySelector('.shopify-section-product-section .rp-sms-link--badge');
      if (productLink) return productLink.dataset.message;
    }
    return link.dataset.message || '';
  }

  function updateLinks(root = document) {
    root.querySelectorAll('[data-rp-sms]').forEach((link) => {
      const url = buildSmsUrl(link.dataset.phone, currentMessage(link), platform);
      if (url) link.href = url;
    });
  }

  function setupWidget() {
    widgetController?.abort();
    const widget = document.querySelector('rp-sms-widget');
    const dialog = widget?.querySelector('dialog');
    if (!widget || !dialog) return;
    widgetController = new AbortController();
    const options = { signal: widgetController.signal };
    widget.querySelector('[data-sms-close]').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('close', () => {
      if (previousTrigger?.isConnected) previousTrigger.focus({ preventScroll: true });
    }, options);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }, options);
    widget.querySelector('[data-sms-copy]').addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const message = widget.querySelector('[data-sms-message]');
      const status = widget.querySelector('[data-sms-status]');
      try {
        await navigator.clipboard.writeText(message.value);
        status.textContent = button.dataset.copiedLabel;
      } catch {
        message.focus();
        message.select();
        status.textContent = button.dataset.selectLabel;
      }
    }, options);
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-rp-sms]');
    if (!link || event.defaultPrevented) return;
    const message = currentMessage(link);
    const url = buildSmsUrl(link.dataset.phone, message, platform);
    if (!url) { event.preventDefault(); return; }
    link.href = url;
    if (platform !== 'desktop' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const dialog = document.querySelector('.rp-sms-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    previousTrigger = link;
    dialog.querySelector('[data-sms-number]').textContent = link.dataset.phone;
    dialog.querySelector('[data-sms-message]').value = message;
    dialog.querySelector('[data-sms-native]').href = url;
    dialog.querySelector('[data-sms-status]').textContent = '';
    if (!dialog.open) dialog.showModal();
  });

  const refresh = () => { updateLinks(); setupWidget(); };
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', () => updateLinks());
}
